'use client'

import PropTypes from 'prop-types'
import MUIStack from '@mui/material/Stack'
import MUIButton from '@mui/material/Button'
import { SaveIcon } from '@repo/ui/SaveIcon'

export const CustomDataSaveButtons = ({ onSave, onCancel, sx = {}, disabled = false, type = 'button' }) => {
  return (
    <MUIStack
      data-testid="CustomDataSaveButtons"
      direction="row"
      justifyContent="flex-start"
      alignItems={'center'}
      gap={2}
      sx={{ cursor: 'pointer', position: 'relative', pl: '34px', height: '40px', ...sx }}
    >
      <MUIButton
        onClick={onCancel}
        variant="text"
        disabled={disabled}
        sx={{ height: '40px', color: 'text.secondary', '&:hover': { backgroundColor: 'transparent' } }}
      >
        Cancel
      </MUIButton>
      <MUIButton
        onClick={onSave}
        type={type}
        variant="contained"
        disabled={disabled}
        sx={{
          height: '40px',
          backgroundColor: 'success.light',
          '&:hover': { backgroundColor: 'success.lightHover' }
        }}
      >
        <SaveIcon sx={{ color: 'white', width: '18px', marginRight: '10px' }} />
        Save
      </MUIButton>
    </MUIStack>
  )
}

CustomDataSaveButtons.propTypes = {
  onSave: PropTypes.func,
  onCancel: PropTypes.func,
  sx: PropTypes.object,
  disabled: PropTypes.bool,
  type: PropTypes.string
}
